<template>
    <div style="display: flex; justify-content: space-evenly">
        <div id="Wrapper" class="flexContainerColCenter" style="overflow:auto">
            <h2>{{ $t('labelprint.Header') }}</h2>
            <h3>{{ $t('labelprint.Subheader1') }}</h3>
            <Grid ref="gridTurniere"
                  :style="{ width: '500px' }"
                  :data-items="gridDataTurniereComputed"
                  :loader="loaderTurniere"
                  :selected-field="selectedFieldTurniere"
                  @rowclick="onRowClickedTurniere"
                  :columns="columnsTurniere">
                <grid-norecords>{{ $t('labelprint.NotificationNoData') }}</grid-norecords>
            </Grid>
            <br />
            <h3>{{ $t('labelprint.Subheader2') }}</h3>
            <div id="Anzeige">
                <kbutton title="$t('labelprint.ExcelExport')" :theme-color="'primary'" @click="exportExcelWithComp">
                    {{ $t('labelprint.ExcelExport') }}
                </kbutton>
                &nbsp;
                <kbutton title="$t('labelprint.PDFExport')" :theme-color="'primary'" @click="exportPDFWithComp">
                    {{ $t('labelprint.PDFExport') }}
                </kbutton>
                <br />
                <pdfexport ref="gridPDFExport"
                           :scale="0.6"
                           :paper-size="'A4'"
                           :landscape="true"
                           margin="2cm"
                           fileName="ExportGesamt.pdf">
                    <Grid :style="{ height: '920px' }"
                          ref="gridAnzeige"
                          :data-items="gridData"
                          :loader="loader"
                          :columns="columns">
                        <grid-norecords>{{ $t('labelprint.NotificationNoData') }}</grid-norecords>
                    </Grid>
                </pdfexport>
            </div>
            <br />
            <br />
        </div>
    </div>
</template>

<script>
    import { Grid, GridToolbar, GridNoRecords } from "@progress/kendo-vue-grid";
    import { RadioGroup } from '@progress/kendo-vue-inputs';
    import { Button } from '@progress/kendo-vue-buttons';
    import { GridPdfExport } from '@progress/kendo-vue-pdf';
    import { saveExcel } from '@progress/kendo-vue-excel-export';
    import config from "@/appdata/config.json";
    import store from '@/store/store.js';

    export default {
        components: {
            Grid: Grid,
            "grid-norecords": GridNoRecords,
            "grid-toolbar": GridToolbar,
            'pdfexport': GridPdfExport,
            'kbutton': Button,
            radiogroup: RadioGroup,
            store
        },
        data: function () {
            return {
                baseUrlTurniere: '',
                baseUrl: '',
                init: { method: "GET", accept: "application/json", headers: {} },
                pageable: false,
                gridDataTurniere: [],
                gridData: [],
                selectedFieldTurniere: "selectedTurniere",
                selectedPrimTurniere: 0,
                columnsTurniere: [
                    { field: "prim", editable: false, hidden: true, width: 100, title: "Prim" },
                    { field: "name", editable: false, width: 230, title: this.$t('labelprint.GridColumnHeaderName') },
                    { field: "ort", editable: false, width: 120, title: this.$t('labelprint.GridColumnHeaderLocation') },
                    { field: "datum", type: "date", format: "{0:dd.MM.yyyy}", editable: false, width: 100, title: this.$t('labelprint.GridColumnHeaderDate') }
                ],
                columns: [
                    { field: "turniertitel", editable: false, width: 500, title: this.$t('labelprint.GridColumnHeaderTitle') },
                    { field: "klasse", editable: false, width: 350, title: this.$t('labelprint.GridColumnHeaderClass') },
                    { field: "platzierung", editable: false, width: 100, title: this.$t('labelprint.GridColumnHeaderPlacement') },
                ],
                loaderTurniere: false,
                loader: false,
                totalTurniere: 0,
                total: 0
            };
        },
        computed: {
            gridDataTurniereComputed() {
                return this.gridDataTurniere.map((item) => ({ prim: item.prim, name: item.name, datum: item.datum, ort: item.ort, selectedTurniere: (item.prim === this.selectedPrimTurniere) }));
            }
        },
        created: function () {
            this.baseUrlTurniere = config[0].ServiceUrl + config[0].ServiceUrlPort + "/TurniereManagement";
            this.getDataTurniere();
        },
        methods: {
            onRowClickedTurniere(event) {
                this.selectedPrimTurniere = event.dataItem.prim;
                //Grid neu laden
                this.baseUrl = config[0].ServiceUrl + config[0].ServiceUrlPort + "/LabelPrintManagement?RefTurniere=" + this.selectedPrimTurniere;
                this.getData();
            },
            getDataTurniere: function (initial) {
                console.log("---->", initial);
                const that = this;
                this.loader = true;

                fetch(
                    this.baseUrlTurniere,
                    //+ "?" + toODataString(this.dataState) + "&$count=true",
                    this.init
                )
                    .then((response) => response.json())
                    .then((json) => {
                        const total = json["@odata.count"];
                        const data = json["data"];
                        that.totalTurniere = total;
                        that.gridDataTurniere = data;
                        this.loaderTurniere = false;
                    });
            },
            getData: function (initial) {
                console.log("---->", initial);
                const that = this;
                this.loader = true;

                fetch(
                    this.baseUrl,
                    //+ "?" + toODataString(this.dataState) + "&$count=true",
                    this.init
                )
                    .then((response) => response.json())
                    .then((json) => {
                        const total = json["@odata.count"];
                        const data = json["data"];
                        that.total = total;
                        that.gridData = data;
                        this.loader = false;
                    });
            },
            exportPDFWithComp: function () {
                this.$refs.gridPDFExport.save(this.gridData);
            },
            exportExcelWithComp: function () {
                saveExcel({
                    data: this.gridData,
                    fileName: "Export",
                    columns: [
                        { field: 'turniertitel', title: this.$t('labelprint.GridColumnHeaderTitle') },
                        { field: 'klasse', title: this.$t('labelprint.GridColumnHeaderClass') },
                        { field: 'platzierung', title: this.$t('labelprint.GridColumnHeaderPlacement') }
                    ]
                });
            },
        },
    };
</script>

 Add "scoped" attribute to limit CSS to this component only
<style scoped>
    @import '../css/main.css';
</style>
